/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-25 17:09:44
 * @LastEditors: liuziwei
 * @Description: 首页金刚位
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="diamonds-container">
    <!-- 循环渲染金刚位 -->
    <view wx:for="{{diamondsList}}" class="diamond-item" wx:class="{{item.gray && 'gray'}}" bindtap="tapDiamond(item)">
      <image wx:if="{{item.icon}}" src="{{item.icon}}" class="icon" mode="aspectFit"/>
      <text wx:if="{{item.text}}" class="text">{{ item.text }}</text>
      <view class="corner-text" wx:if="{{item.cornerText}}">{{ item.cornerText }}</view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      diamondsConf: {
        type: Array,
        value: () => []
      }
    },
    computed: {
      diamondsList() {
        return this.diamondsConf.filter((item) => !item.hide)
      }
    },
    methods: {
      // 点击金刚位
      tapDiamond({ type }) {
        // 上报点击事件
        this.triggerEvent('pageGoTo', { type })
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .diamonds-container
    height 78px
    border-radius 16px
    background #fff
    display flex
    padding 0 12px
    // align-items center
    justify-content space-around
    .diamond-item
      display flex
      align-items center
      flex-direction column
      position relative
      line-height 1
      letter-spacing 0px
      font-weight 400
      margin-top 10px
      .icon
        width 40px
        height 40px
      .text
        font-family PingFang SC
        font-size 12px
        text-align center
        color #666
      .corner-text
        position absolute
        padding 3px 6px
        white-space nowrap
        top 3px
        left 24px
        transform scale(0.5)
        transform-origin left top
        background: #FF4129
        border-radius 12px 12px 12px 2px
        font-family PingFangSC-Medium
        font-size 18px
        color #fff
      &.gray
        opacity 0.3
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>
